import { gql } from '@apollo/client'

export const CREATE_NOTE = gql`
  mutation CreatePersonNote($payload: CreateNoteInput) {
    createNote(payload: $payload) {
      id
      account_id
      created_at
      created_by {
        id
        email
        first_name
        last_name
      }
      content
      deleted
      updated_at
      updated_by_id
    }
  }
`
